import axios from "axios";
import { API_URL, MEDIA_API_URL } from "../../constants";

export const GetSinglePost = async (postid, ApiStatus) => {
    ApiStatus({ isLoader: true, isError: false, data: null });
    const token = sessionStorage.getItem('LOGIN_TOKEN');
    try {
        let res = await axios.get(MEDIA_API_URL + "posts/post_by_id/" + postid, {
            headers: {
                'Authorization': "Bearer " + token
            }
        });
        ApiStatus({ isLoader: false, isError: false, data: res.data });
    } catch (err) {
        ApiStatus({ isLoader: false, isError: true, data: null });
    }

}